import { PropsWithClassName } from "../../../models/props-with-class-name";
import styles from "./ActiveIndicator.module.css";

type ActiveIndicatorProps = PropsWithClassName<{
  active?: boolean;
}>;

const ActiveIndicator = ({ active, className }: ActiveIndicatorProps) => (
  <div
    className={`${styles.indicator} ${
      active ? styles.active : ""
    } ${className}`}
  ></div>
);

export default ActiveIndicator;
